export const SET_VENDOR_OPPORTUNITY = 'INSURANCE_SET_VENDOR_OPPORTUNITY';
export const SET_CREDIT_APPLICATION = 'INSURANCE_SET_CREDIT_APPLICATION';
export const SET_SUBMISSIONS = 'INSURANCE_SET_SUBMISSIONS';
export const SET_IS_INSURANCE_EXPRESS_INTEGRATED = 'SET_IS_INSURANCE_EXPRESS_INTEGRATED';
export const SET_PROPOSALS = 'INSURANCE_SET_PROPOSALS';
export const SET_FINANCE_PROGRAMS = 'INSURANCE_SET_FINANCE_PROGRAMS';
export const SET_SELECTED_SUBMISSION = 'INSURANCE_SET_SELECTED_SUBMISSION';
export const SET_SELECTED_FINANCE_PROGRAM = 'INSURANCE_SET_SELECTED_FINANCE_PROGRAM';
export const SET_STEPPER_CONFIG = 'INSURANCE_SET_STEPPER_CONFIG';
export const SET_ACCORDION_CONFIG = 'INSURANCE_SET_ACCORDION_CONFIG';
export const UPDATE_STEPPER_CONFIG = 'INSURANCE_UPDATE_STEPPER_CONFIG';
export const UPDATE_ACCORDION_CONFIG = 'INSURANCE_UPDATE_ACCORDION_CONFIG';
export const SET_INSURANCE_BROKER = 'INSURANCE_SET_INSURANCE_BROKER';
export const SET_INSURANCE_VERIFICATION_TASK = 'INSURANCE_SET_INSURANCE_VERIFICATION_TASK';
export const SET_INSURANCE_CERTIFICATE = 'INSURANCE_SET_INSURANCE_CERTIFICATE';
export const SET_COVERAGE_STATUS_CONFIG = 'INSURANCE_SET_COVERAGE_STATUS_CONFIG';
export const CLEAR_STATE = 'INSURANCE_CLEAR_STATE';
